import { FETCH_FILTERED_PRODUCTS_REQUEST, FETCH_FILTERED_PRODUCTS_SUCCESS, FETCH_FILTERED_PRODUCTS_FAILURE } from '../actions/FilterActions';

const defaultFilters = {
  search: '',
  tags: [],
  features: [],
  skin_concern: [],
  skin_type: [],
  formulation: [],
  keywords: [],
  brand: '',
  min_price: null,
  max_price: null,
  category_id: [],
};

const initialState = {
  filteredProducts: [],
  loading: false,
  error: null,
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_FILTERS':
      return { ...state, ...action.payload };
    case 'CLEAR_FILTERS':
      return defaultFilters;
    case 'SET_PRICE_RANGE':
      return {
        ...state,
        min_price: action.payload.min,
        max_price: action.payload.max
      };
    case 'SET_CATEGORY_ID':
      return {
        ...state,
        category_id: action.payload
      };
    case FETCH_FILTERED_PRODUCTS_REQUEST:
      return { ...state, loading: true };
    case FETCH_FILTERED_PRODUCTS_SUCCESS:
      return {
        ...state,
        loading: false,
        filteredProducts: action.payload.products.results || [],
        count: action.payload.products.count || 0,
        next: action.payload.products.next,
        previous: action.payload.products.previous
      };
    case FETCH_FILTERED_PRODUCTS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default filterReducer;